export type JwtPayload = Record<string, unknown>;

const decodeBase64Url = (value: string): string => {
  const normalized = value.replace(/-/g, '+').replace(/_/g, '/');
  const padding = normalized.length % 4;
  const padded = padding === 0 ? normalized : normalized + '='.repeat(4 - padding);
  return atob(padded);
};

export const parseJwtPayload = <T extends JwtPayload = JwtPayload>(token: string): T | null => {
  const tokenParts = token.split('.');
  if (tokenParts.length !== 3) {
    return null;
  }

  try {
    const payloadJson = decodeBase64Url(tokenParts[1]);
    const payload = JSON.parse(payloadJson) as unknown;
    if (!payload || typeof payload !== 'object') {
      return null;
    }
    return payload as T;
  } catch {
    return null;
  }
};